import { RouteRecordRaw } from 'vue-router'
import routes from '@/router/routes'
import ViewManager from '@/utils/ViewManager'

export const Views = new ViewManager()
const rootChildSubRoutes: RouteRecordRaw | undefined = (routes.authed.concat(routes.static)).find(r => r.path === '/')

if (rootChildSubRoutes) Views.fromRoutes([rootChildSubRoutes])

export default Views.instance
